import { Component } from '@angular/core';

@Component({
  selector: 'app-como-funciona-sorteio',
  templateUrl: './como-funciona-sorteio.component.html',
  styleUrls: ['./como-funciona-sorteio.component.css']
})
export class ComoFuncionaSorteioComponent {
}



// WEBPACK FOOTER //
// ./src/app/publico/sorteios/como-funciona-sorteio/como-funciona-sorteio.component.ts